import type { IconName } from '@raiadrogasil/pulso-icons'
import { useMemo } from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import { useInputCounterContext } from '../../input-counter'
import type { InputCounterScopedProps } from '../../input-counter.types'
import {
  inputCounterHelperTextContainerVariants,
  inputCounterHelperTextMessageVariants,
} from './input-counter-helpertext.styles'

type InputCounterHelperTextProps = {
  iconName?: IconName
  children: React.ReactNode
}

export const InputCounterHelperText = (props: InputCounterHelperTextProps) => {
  const {
    children,
    iconName = '',
    __scopeInputCounter,
  } = props as InputCounterScopedProps<InputCounterHelperTextProps>

  const { hasError, disabled, readOnly } = useInputCounterContext(
    'InputCounterHelperText',
    __scopeInputCounter
  )
  const symbol = hasError ? 'rdicon-warning-circle' : iconName

  const iconColor = useMemo((): TIconProps['color'] => {
    if (disabled) return 'colorTextNeutralDisabled'
    if (readOnly) return 'colorTextNeutralReadonly'
    if (hasError) return 'colorTextDangerAlternative'
    return 'colorTextNeutralAlternative'
  }, [disabled, hasError, readOnly])

  if (!children) return null

  const displayIcon = hasError || iconName !== ''

  return (
    <div
      {...props}
      aria-disabled={disabled}
      className={inputCounterHelperTextContainerVariants({})}
    >
      {displayIcon && (
        <div className="mr-onepulse flex items-center">
          <Icon
            symbol={symbol as TIconProps['symbol']}
            color={iconColor}
            size="tiny"
          />
        </div>
      )}
      <span
        className={inputCounterHelperTextMessageVariants({
          hasError,
          disabled,
          readOnly,
        })}
      >
        {children}
      </span>
    </div>
  )
}
